import Loadable from "../../react-loadable";
import ActionButtons from "./ActionButtons";
import TableCell from "./TableCell";

const Table = Loadable({
  loader: () => import("./Table"),
  loading: () => null,
  render: (obj, props, ref) => {
    if (obj) {
      return React.createElement(obj && obj.__esModule ? obj.default : obj, {
        ...props,
        ref
      });
    }
    return null;
  }
});

Table.TableCell = TableCell;
Table.ActionButtons = ActionButtons;
export default Table;



// WEBPACK FOOTER //
// ./ecology9/wea-table-editable/index.js